export default __webpack_public_path__ + "static/media/form-spikepattern.c1e536b4.webp";